// GroupBlock — composition primitive that lays out child blocks together
// as one visual unit. Variants drive the CSS arrangement: "card" wraps the
// children in a bordered box (status-card style); "row" / "column" set flex
// direction; "accent-bar" adds the 2px left brand bar from the editorial-
// glass design.
//
// GroupBlock itself doesn't dispatch its children — the <Slot> component
// recurses into the children when it encounters this block kind, so the
// dispatcher logic lives in exactly one place (Slot.tsx).

import type { ReactNode } from "react";
import type { BlockUniversalProps } from "./types";

export interface GroupBlockProps extends BlockUniversalProps {
  variant?: "card" | "row" | "row-right" | "column" | "accent-bar";
  /** Pre-rendered children. Slot.tsx walks the BlockInstance children and
   *  hands them in already-expanded. */
  children?: ReactNode;
}

export function GroupBlock({ variant = "column", themeVariant, className, children }: GroupBlockProps) {
  return (
    <div
      className={"sd-block-group sd-block-group--" + variant + (className ? " " + className : "")}
      data-variant={themeVariant}
    >
      {children}
    </div>
  );
}
